import messages from '../../../locale/jsonMessages';

const smsEventMessages = {
  otp: messages.smsEventOtp,
  booking_requested: messages.smsEventBookingRequested,
  booking_confirmed: messages.smsEventBookingConfirmed,
  booking_declined: messages.smsEventBookingDeclined,
  booking_cancelled: messages.smsEventBookingCancelled,
  booking_expired: messages.smsEventBookingExpired,
  test_otp: messages.smsTestEventOtp,
  test_booking_requested: messages.smsTestEventBookingRequested,
  test_booking_confirmed: messages.smsTestEventBookingConfirmed,
  test_booking_cancelled: messages.smsTestEventBookingCancelled,
};

export function getSmsEventLabel(intl, event) {
  return intl.formatMessage(smsEventMessages[event] || messages.smsEventUnknown, { event });
}

const smsTestEventNames = {
  test_otp: messages.smsEventOtp,
  test_booking_requested: messages.smsEventBookingRequested,
  test_booking_confirmed: messages.smsEventBookingConfirmed,
  test_booking_cancelled: messages.smsEventBookingCancelled,
};

export function getSmsTestEventName(intl, event) {
  return intl.formatMessage(smsTestEventNames[event] || messages.smsEventUnknown, { event });
}

const smsErrorMessages = {
  phone_unverified: messages.smsErrorPhoneUnverified,
  invalid_phone: messages.smsErrorInvalidPhone,
  missing_configuration: messages.smsErrorMissingConfiguration,
  invalid_sender: messages.smsErrorInvalidSender,
  invalid_base_url: messages.smsErrorInvalidBaseUrl,
  http_401: messages.smsErrorHttp401,
  http_403: messages.smsErrorHttp403,
  rate_limited: messages.smsErrorRateLimited,
  provider_rejected: messages.smsErrorProviderRejected,
  worker_interrupted: messages.smsErrorWorkerInterrupted,
  sms_disabled: messages.smsErrorSmsDisabled,
  activation_baseline: messages.smsErrorActivationBaseline,
  internal_error: messages.smsErrorInternal,
};

export function getSmsErrorLabel(intl, code) {
  return code ? intl.formatMessage(smsErrorMessages[code] || messages.smsErrorUnknown, { code }) : '';
}
